import type { IFormula } from '~/services/parallel/formulas.types';
import * as stringDate from '~/utils/stringDate';

export const filterExpenseFormulas = ({
  expenseFormulas,
  search,
  category,
  frequency,
  showPastExpenses,
}: {
  expenseFormulas: IFormula[];
  search?: string;
  category: string | null;
  frequency: string | null;
  showPastExpenses: boolean;
}): IFormula[] => {
  return expenseFormulas.filter((formula) => {
    const searchMatch = !search || formula.recipe.name.toLowerCase().includes(search.toLowerCase());

    const categoryMatch = !category || category === 'all' || formula.context?.expenseContext?.tag === category;

    const frequencyMatch =
      !frequency || frequency === 'all' || formula.context?.expenseContext?.frequency === frequency;

    const pastExpenseMatch =
      showPastExpenses ||
      !formula.recipe.endDate ||
      stringDate.isSameMonthOrAfter({
        dateToCheck: formula.recipe.endDate,
        comparison: stringDate.getStringDate(),
      });

    return searchMatch && categoryMatch && frequencyMatch && pastExpenseMatch;
  });
};
